import React from 'react';
import { Divider, Typography } from '@mui/material';
import compost from '../../../../../images/Agri-info/crops/compost_কম্পোস্ট.jpg';
import useDocumentTitle from '../../../../../hooks/useDocumentTitle';

const CompostInfo = () => {

    // dynamic title
    useDocumentTitle("কম্পোস্ট");

    return (

        <div className=" rounded-3 bg-white my-4 px-5">
            <Typography
                sx={{
                    textAlign: "center",
                    pb: 2,
                    pt: 3,
                    fontWeight: 600,
                    color: 'rgb(37, 36, 36, 0.83)'
                }}
                variant="h3"
                noWrap
                component="div"
            >
                কম্পোস্ট
            </Typography>
            <Divider />

            <div className="card mt-4 mb-3 border-0 rounded-0">
                <div className="row g-0">
                    <div className="col-md-4">
                        <img src={compost} className="img-fluid rounded-0 h-100" alt="..." />
                    </div>
                    <div className="col-md-8">
                        <div className="card-body text-start ">
                            <p className="card-text"><b>আপনি জানেন কি?</b><br />
                                - বর্তমানে জমিতে অধিক উৎপাদনের লক্ষ্যে প্রচুর পরিমানে রাসায়নিক সার ব্যবহার করা হয়।<br />
                                - তবে ব্যাপকহারে এ রাসায়নিক সার ব্যবহারের ফলে জমিতে এর বিরূপ প্রভাব ও পড়ে ।<br />
                                - সাথে সাথে জমিতে জৈব পদার্থ ও উপকারী অনুজীবের পরিমান হ্রাস পেতে থাকে।<br />
                                - এছাড়া জমির পুষ্টি উপাদানের মাত্রা ও ক্রমশ কমে যেতে থাকে। এজন্য জমিতে কম্পোষ্ট ব্যবহার খুবই প্রয়োজনীয়</p>
                            <p className="card-text"><b>কম্পোস্ট তৈরির উপাদান</b><br />যেসব উপাদান দিয়ে কম্পোস্ট তৈরি করা যায়, তা হলো-</p>

                        </div>
                    </div>
                </div>
            </div>

            <div className='text-start pb-5'>
                <p>- ফসলের অবশিষ্টাংশ<br /> - কচুরীপানা<br /> - সবজি বা ফলের খোসা<br /> - আগাছা<br /> - বসতবাড়ির ময়লা আবর্জনা ও<br /> - খড়কুটা</p>
                <p className="card-text"><b>স্তূপ পদ্ধতিতে কম্পোস্ট</b><br />বসতবাড়ির আশপাশে, ক্ষেতের ধারে অথবা পুকুর বা ডোবার কাছে স্তূপ পদ্ধতিতে কম্পোস্ট তৈরি করা যায়। এজন্য খেয়াল রাখতে হবে, যেন স্থানটি বেশ উঁচু হয়, যাতে সেখানে বর্যার পানি জমে না থাকে। এ ধরনের উঁচু স্থান যদি গাছের ছায়ার নিচে হয় এবং সেখানে স্তূপ করা যায় তাহলে খুবই ভালো কম্পোস্ট তৈরি করা যায়। কারণ গাছের ছায়া রোদ বৃষ্টি প্রতিরোধ করবে এবং জৈব পদার্থের পচন ক্রিয়ায় সাহায্য করবে। বর্ষাকালে অথবা যেসব এলাকায় বৃষ্টিপাতের পরিমাণ বেশি, সেসব এলাকায় স্তূপ পদ্ধতিতে তৈরি কম্পোস্ট বেশ কার্যকর। গ্রাম বাংলায় এ পদ্ধতিকে গাদা পদ্ধতি বলা হয়।</p>
                <p className="card-text"><b>তৈরির নিয়ম : </b><br />কম্পোস্ট তৈরির জন্য প্রথমে ৩-৪ দিনের শুকনো কচুরিপানা ও অন্যান্য আবর্জনা ফেলে ১৫ সেমি. পুরু স্তর সাজাতে হবে। এ ক্ষেত্রে তাজা বা সবুজ কচুরিপানা ব্যবহার উচিত নয়, এতে পটাশ ও নাইট্রোজেনের উপাদান নষ্ট হয়। কচুরিপানা বেশি লম্বা হলে তা ১৫ সেমি. করে কেটে ব্যবহার করতে হবে।</p>
                <p>এরপর এ স্তরের ওপর ২০০ গ্রাম ইউরিয়া এবং ২০০ গ্রাম টিএসপি সার ছিটিয়ে দেয়া ভালো। এতে পচনক্রিয়া ত্বরান্বিত হয়। সার ছিটানোর পর স্তরের ওপর ২.৫০-৫.০০ সেমি. পুরু করে গোবর এবং কাদা মাটির একটি প্রলেপ দিতে  হবে। এর  ফলে  স্তরের  ভেতর  জীবাণুর  ক্রিয়া  বেড়ে যাবে এবং দ্রুত পচন কাজ   সম্পন্ন হবে।  এভাবে১.২৫ মি.উঁচু না হওয়া পর্যন্ত বারবার ১৫ সেমি. পুরু করে শুকনো কচুরিপানা,আবর্জনা, খড়কুটো দিয়ে স্তর সাজাতে হবে এবং  ২.৫০-৫.০০ সেমি. পুরু করে গোবর ও কাদা মাটি দিয়ে লেপে দিতে হবে। গাদা তৈরি শেষ হলে এর উপরিভাগ মাটি দিয়ে লেপে দিতে হবে এবং সম্ভব হলে কম্পোস্ট স্তূপ ওপর ছায়ার ব্যবস্থা করতে হবে।<br />
                    স্তূপ বা গাদা তৈরির কাজ শেষ হওয়ার এক সপ্তাহ পর একটি শক্ত কাঠি গাদার মাঝখানে ভিতরের দিকে দিয়ে স্তরগুলো অতিরিক্ত ভেজা কিনা তা দেখে নিতে হবে। যদি ভেজা থাকে, তাহলে শক্ত কাঠি দিয়ে গাদার উপর থেকে মাঝে মাঝে ছিদ্র করে দিতে হবে, যাতে বাতাস ভিতরে ঢুকতে পারে। এরপর গাদার ভিতরের অংশ শুকিয়ে গেলে ছিদ্রগুলো বন্ধ করে দিতে হবে। লক্ষ্য রাখতে হবে গাদ যেন অতিরিক্ত শুকিয়ে না যায়। যদি অতিরিক্ত শুকিয়ে যায়, তাহলে ছিদ্র পথে পানি বা গো-চনা ঢেলে গাদাকে স্বাভাবিক অবস্থায় ফিরিয়ে আনতে হবে।</p>
                <p>পর্যাপ্ত পরিমানে গোবর, গো-চনা এবং ইউরিয়া গাদাতে ব্যবহার করা হলে স্তূপ তৈরির প্রায় ৩ মাসের মধ্যে  তৈরি কম্পোস্ট জমিতে ব্যবহারের উপযুক্ত হবে। আঙ্গুল দিয়ে চাপ দিলে যদি কম্পোস্ট গুড়াঁ হয়ে যায় তাহলে বুঝতে হবে তা জমিতে ব্যবহারের উপযোগী হয়েছে।</p>

                <p className="card-text"><b>কম্পোস্ট ব্যবহারের উপকারীতা</b><br />
                    কম্পোস্ট ব্যবহারে-<br />
                    ১.    মাটির পুষ্টিমান বৃদ্ধি করে ও মাটিকে সমৃদ্ধ করে।<br />
                    ২.    বেলে মাটির পানি ধারণ ক্ষমতা বৃদ্ধি করে এবং পুষ্টি উপাদান যুক্ত করে।<br />
                    ৩.    এটেল মাটিকে ঝুরঝুরে করে ও এর বায়ুচলাচল বৃদ্ধি করে।<br />
                    ৪.    সবজি ফসলে মালচিং এর কাজ করে।<br />
                    ৫.    ভূমিক্ষয় রোধ করতে সহায়তা করে।<br />
                    ৬.    মাটিতে উপকারী অনুজীবের কার্যক্রম বৃদ্ধি করে।<br />
                    ৭.    মাটির পি-এইচ বা রাসায়নিক বিক্রিয়ার মান নিরপেক্ষ রাখতে সহায়তা করে।<br />
                    ৮.    পট অথবা টবের মাটির সহিত কম্পোস্ট ব্যবহার করে চারা রোপন করা হয়।</p>

            </div>
        </div >

    );
};

export default CompostInfo;